import { defineMessages } from 'react-intl';

export default defineMessages({
  lock: {
    id: 'cboard.components.LockToggle.lock',
    defaultMessage: 'Lock'
  },
  unlock: {
    id: 'cboard.components.LockToggle.unlock',
    defaultMessage: 'Unlock'
  }
});
